export default __webpack_public_path__ + "static/media/Group 36.8f77c118.png";